import axios from '../../../api/axiosConfig';


export const SET_CALENDAR_COLORS = 'SET_CALENDAR_COLORS';
export const UPDATE_CALENDAR_COLOR = 'UPDATE_CALENDAR_COLOR';

const initialState = {
    globalTasks: '#D5D6FF',
    primary: '#E5F6D1',
    timetable: '#BBE7FC'
};

const calendarColorsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CALENDAR_COLORS:
            return {
                ...state,
                ...action.payload
            };
        case UPDATE_CALENDAR_COLOR:
            return {
                ...state,
                [action.payload.calendarType]: action.payload.color
            };
        default:
            return state;
    }
};

export default calendarColorsReducer;